module.exports = __webpack_public_path__ + "media/categories/2018-00348f62.svg";